<template>
  <div>
    <v-card>
      <v-card-title>
        Hildegarde's Food Pantry
      </v-card-title>

      <v-card-subtitle>
        General Report
      </v-card-subtitle>

      <hr>
      <br>
      <br>

      <v-card-text>
        <p><strong>User:</strong> Main Office</p>
        <p><strong>Report Dates:</strong> {{ selectedDates }}</p>
        <p><strong>Total Served:</strong> {{ statisticsData[0].total }} <small>members</small></p>
        <p><strong>Total Household:</strong> {{ statisticsData[1].total }} <small>members</small></p>

        <br>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Category
                </th>
                <th class="text-left">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in chartData"
                :key="item.id"
              >
                <td>{{ item.ethnicity }}</td>
                <td>{{ item.total }} <small>members</small></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <br>
      <br>

      <v-card-actions>
        <p class="text-right">
          <strong>Report generated on: {{ today }}</strong>
        </p>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    statisticsData: {
      type: Array,
      default: () => [],
    },
    selectedDates: {
      type: String,
      default: () => '',
    },
  },

  setup() {
    const today = new Date()
      .toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })

    return {
      today,
    }
  },
}
</script>
